import type { AluminiumAISampleComposition, AluminiumComposition } from 'api';

export const isAluminiumAISampleComposition = (
  composition: AluminiumComposition | AluminiumAISampleComposition
): composition is AluminiumAISampleComposition => 'foil_and_tray' in composition;
